import { BaseHttpService } from './../../app/shared/base-http/base-http.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { config } from '../../config/config';
import { CgpApiService } from '../cgp-api';
import { getEnv } from '../utility';

@Injectable()
export class FileDownloadApiService {
    constructor(
        private readonly http: BaseHttpService
    ) { }

    public downloadFile(url) {
        return this.http.get(`${config.tprecmApiBaseUrl[getEnv()]}${url}`);
    }

    public downloadFileWithBody(url, body) {
        return this.http.post(`${config.tprecmApiBaseUrl[getEnv()]}${url}`, body);
    }
}
